/* ============================================================
   THG - Bloque de Ganger Points en el carrito
   ------------------------------------------------------------
   Este codigo vivia dentro de cart-drawer.liquid. Cuando Moxie
   repinta el drawer inyecta el HTML con innerHTML, y en ese caso
   el navegador NO ejecuta las etiquetas script que vengan dentro.
   Por eso el boton de ver mis puntos dejaba de responder hasta
   recargar la pagina.

   Como asset se carga una sola vez y ya no depende del repintado.

   Cargar desde layout/theme.liquid antes del cierre de body:
     script src asset_url thg-loyalty-cart.js defer
   ============================================================ */

(function(){
                      // Los listeners van a nivel de documento porque Moxie re-renderiza
                      // el drawer y el <script> interno no se vuelve a ejecutar.
                      if(window.__thgLty) { window.__thgLty.hydrate(); return; }

                      var API = 'https://thgtrack.com/api/loyalty';
                      var LS_KEY = 'thg_loyalty_email';
                      var state = { email:'', data:null, merchAdded:0 };

                      var STR = {
                        es: {
                          convert:'CONVERTIR', redeem:'CANJEAR', points:'POINTS',
                          mp:' MP', need:' \u00b7 te faltan ', needShort:' \u00b7 faltan ',
                          added:'agregado', addedPl:'agregados',
                          noPoints:'No encontramos puntos con ese correo.',
                          connErr:'Error de conexion. Intenta de nuevo.',
                          needPaid:'Agrega un producto al carrito antes de canjear tu regalo.',
                          failRedeem:'No se pudo completar el canje.',
                          okMerch:' agregado a tu carrito.',
                          okCash1:'Listo. ', okCash2:' en tu cuenta. Inicia sesion al pagar y marca "Aplicar credito en tienda".',
                          noteCash:'Al pagar, inicia sesion y marca <b>Aplicar credito en tienda</b>. Si no lo usas ahora, el saldo queda guardado.',
                          noteMerch:'Requiere al menos un producto pago en el carrito.'
                        },
                        en: {
                          convert:'CONVERT', redeem:'REDEEM', points:'POINTS',
                          mp:' points', need:' \u00b7 you need ', needShort:' \u00b7 need ',
                          added:'added', addedPl:'added',
                          noPoints:'We could not find points for that email.',
                          connErr:'Connection error. Please try again.',
                          needPaid:'Add a product to your cart before redeeming your reward.',
                          failRedeem:'We could not complete the redemption.',
                          okMerch:' added to your cart.',
                          okCash1:'Done. ', okCash2:' in your account. Sign in at checkout and select "Apply store credit".',
                          noteCash:'At checkout, sign in and select <b>Apply store credit</b>. If you do not use it now, the balance stays saved.',
                          noteMerch:'Requires at least one paid product in the cart.'
                        }
                      };
                      function T(){ return STR[cfg('lang','es')] || STR.es; }

                      function root(){ return document.querySelector('.thg-lty'); }
                      function q(sel){ var r = root(); return r ? r.querySelector(sel) : null; }
                      function show(n, on){ if(n) n.hidden = !on; }
                      function cfg(k, d){ var r = root(); return (r && r.dataset[k]) || d; }

                      function msg(which, text){
                        show(q('[data-lty-err]'), false);
                        show(q('[data-lty-ok]'), false);
                        if(!text) return;
                        var n = q(which === 'err' ? '[data-lty-err]' : '[data-lty-ok]');
                        if(n){ n.textContent = text; show(n, true); }
                      }

                      function fmt(n){
                        if(cfg('store','co') === 'us') return '$' + n + ' USD';
                        return '$' + Number(n).toLocaleString('es-CO') + ' COP';
                      }

                      function render(){
                        var d = state.data; if(!d || !root()) return;
                        var STORE = cfg('store','co');
                        q('[data-lty-balance]').textContent = d.points_available + T().mp;
                        var tier = q('[data-lty-tier]');
                        if(tier && d.tier){ tier.textContent = String(d.tier).toUpperCase(); show(tier, true); }
                        var cash = (d.rewards||[]).filter(function(r){ return r.type === 'cash'; });
                        var cs = q('[data-lty-cash-sub]');
                        if(cs) cs.textContent = cash.map(function(r){ return r.cost + T().mp + ' = ' + fmt(r.value[STORE]); }).join('  \u00b7  ');
                        var ms = q('[data-lty-merch-sub]');
                        if(ms) ms.textContent = state.merchAdded + ' ' + (state.merchAdded === 1 ? T().added : T().addedPl);
                        show(q('[data-lty-ident]'), false);
                        show(q('[data-lty-body]'), true);
                        panel('cash'); panel('merch');
                      }

                      function panel(kind){
                        var el = q('[data-lty-panel="'+kind+'"]');
                        if(!el || !state.data) return;
                        var STORE = cfg('store','co');
                        var items = (state.data.rewards||[]).filter(function(r){ return r.type === kind; });
                        var avail = state.data.points_available;

                        if(kind === 'merch'){
                          items.sort(function(a,b){ return a.cost - b.cost; });
                          el.innerHTML = '<div class="thg-lty__grid">' + items.map(function(r){
                            var can = avail >= r.cost;
                            var img = (r.image && r.image[STORE]) ? r.image[STORE] : '';
                            var src = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
                            return '<div class="thg-lty__card' + (can ? '' : ' thg-lty__card--off') + '"><div class="thg-lty__card-in">' +
                              (src ? '<img src="' + src + '" alt="' + r.label + '" loading="lazy">' : '') +
                              '<span class="thg-lty__card-t">' + r.label + '</span>' +
                              '<span class="thg-lty__card-c">' + r.cost + T().mp + (can ? '' : T().needShort + (r.cost - avail)) + '</span>' +
                              '<button type="button" class="thg-lty__btn" data-lty-redeem="' + r.id + '" data-lty-type="merch"' + (can ? '' : ' disabled') + '>' + T().redeem + '</button>' +
                            '</div></div>';
                          }).join('') + '</div>' +
                          '<p class="thg-lty__note">' + T().noteMerch + '</p>';
                        } else {
                          el.innerHTML = items.map(function(r){
                            var can = avail >= r.cost;
                            var sub = can ? r.cost + T().mp : r.cost + T().mp + T().need + (r.cost - avail) + T().mp;
                            return '<div class="thg-lty__opt">' +
                              '<span class="thg-lty__opt-main">' +
                                '<span class="thg-lty__opt-title">Ganger Cash ' + fmt(r.value[STORE]) + '</span>' +
                                '<span class="thg-lty__opt-sub">' + sub + '</span>' +
                              '</span>' +
                              '<button type="button" class="thg-lty__btn" data-lty-redeem="' + r.id + '" data-lty-type="cash"' + (can ? '' : ' disabled') + '>' + r.cost + ' ' + T().points + '</button>' +
                            '</div>';
                          }).join('') +
                          '<p class="thg-lty__note">' + T().noteCash + '</p>';
                        }
                      }

                      function lookup(email, silent){
                        if(!email) return;
                        state.email = email;
                        try { localStorage.setItem(LS_KEY, email); } catch(e){}
                        if(!silent) msg(null);
                        var btn = q('[data-lty-lookup]');
                        if(btn) btn.disabled = true;
                        fetch(API + '/me?email=' + encodeURIComponent(email))
                          .then(function(r){ return r.json(); })
                          .then(function(d){
                            if(d && d.points_available !== undefined){ state.data = d; render(); }
                            else if(!silent) msg('err', T().noPoints);
                          })
                          .catch(function(){ if(!silent) msg('err', T().connErr); })
                          .then(function(){ var b = q('[data-lty-lookup]'); if(b) b.disabled = false; });
                      }

                      function refreshCart(){
                        var SECTION = cfg('section','');
                        if(!SECTION){ window.location.reload(); return; }
                        return fetch(window.location.pathname + '?sections=' + SECTION, { headers:{'Accept':'application/json'} })
                          .then(function(r){ return r.json(); })
                          .then(function(data){
                            var html = data[SECTION];
                            if(!html) throw new Error('sin seccion');
                            var doc = new DOMParser().parseFromString(html, 'text/html');
                            var nuevo  = doc.querySelector('.hdt-mini-cart__items');
                            var actual = document.querySelector('.hdt-mini-cart__items');
                            if(nuevo && actual) actual.innerHTML = nuevo.innerHTML;
                            else { window.location.reload(); return; }
                            var nTot = doc.querySelector('[data-er-cart-total-price]');
                            var aTot = document.querySelector('[data-er-cart-total-price]');
                            if(nTot && aTot) aTot.innerHTML = nTot.innerHTML;
                            var nCnt = doc.querySelector('hdt-cart-count');
                            if(nCnt) document.querySelectorAll('hdt-cart-count').forEach(function(c){ c.textContent = nCnt.textContent; });
                            document.dispatchEvent(new CustomEvent('cart:refresh'));
                            document.dispatchEvent(new CustomEvent('cart:update'));
                          })
                          .catch(function(){ window.location.reload(); });
                      }

                      function cartHasPaidItem(){
                        return fetch('/cart.js', { headers:{'Accept':'application/json'} })
                          .then(function(r){ return r.json(); })
                          .then(function(c){ return (c.items||[]).some(function(i){ return (i.original_line_price || i.line_price || 0) > 0; }); })
                          .catch(function(){ return true; });
                      }

                      function redeem(id, type, btn){
                        msg(null);
                        btn.disabled = true;
                        var STORE = cfg('store','co');
                        var step = type === 'merch' ? cartHasPaidItem() : Promise.resolve(true);

                        step.then(function(ok){
                          if(!ok){ msg('err', T().needPaid); btn.disabled = false; return null; }
                          return fetch(API + '/redeem', {
                            method:'POST', headers:{'Content-Type':'application/json'},
                            body: JSON.stringify({ email: state.email, reward_id: id, store: STORE })
                          }).then(function(r){ return r.json(); });
                        })
                        .then(function(d){
                          if(!d) return;
                          if(!d.ok) throw new Error(d.error || T().failRedeem);
                          state.data.points_available = d.points_available;
                          if(d.type === 'merch'){
                            return fetch('/cart/add.js', {
                              method:'POST', headers:{'Content-Type':'application/json'},
                              body: JSON.stringify({ id: d.variant_id, quantity: 1 })
                            })
                            .then(function(r){ return r.json(); })
                            .then(function(){
                              state.merchAdded++;
                              msg('ok', d.reward + T().okMerch);
                              return refreshCart();
                            });
                          }
                          msg('ok', T().okCash1 + fmt(d.credit_amount) + T().okCash2);
                        })
                        .catch(function(e){ msg('err', e.message || T().failRedeem); })
                        .then(function(){ render(); });
                      }

                      document.addEventListener('click', function(e){
                        if(!e.target.closest || !e.target.closest('.thg-lty')) return;

                        var t = e.target.closest('[data-lty-toggle]');
                        if(t){
                          var r0 = root();
                          var open = t.getAttribute('aria-expanded') === 'true';
                          r0.querySelectorAll('[data-lty-toggle]').forEach(function(o){
                            o.setAttribute('aria-expanded','false');
                            show(r0.querySelector('[data-lty-panel="'+o.dataset.ltyToggle+'"]'), false);
                          });
                          if(!open){
                            t.setAttribute('aria-expanded','true');
                            show(r0.querySelector('[data-lty-panel="'+t.dataset.ltyToggle+'"]'), true);
                            setTimeout(function(){ t.scrollIntoView({ block:'nearest' }); }, 30);
                          }
                          return;
                        }

                        var rb = e.target.closest('[data-lty-redeem]');
                        if(rb && !rb.disabled){ redeem(rb.dataset.ltyRedeem, rb.dataset.ltyType, rb); return; }

                        if(e.target.closest('[data-lty-lookup]')){
                          var inp = q('[data-lty-email]');
                          lookup(inp ? inp.value.trim().toLowerCase() : '', false);
                          return;
                        }

                        if(e.target.closest('[data-lty-reset]')){
                          try { localStorage.removeItem(LS_KEY); } catch(err){}
                          state.email = ''; state.data = null; state.merchAdded = 0;
                          var i2 = q('[data-lty-email]'); if(i2) i2.value = '';
                          show(q('[data-lty-body]'), false);
                          show(q('[data-lty-ident]'), true);
                          show(q('[data-lty-tier]'), false);
                          msg(null);
                        }
                      });

                      document.addEventListener('keydown', function(e){
                        if(e.key !== 'Enter') return;
                        if(!e.target.matches || !e.target.matches('[data-lty-email]')) return;
                        e.preventDefault();
                        lookup(e.target.value.trim().toLowerCase(), false);
                      });

                      function hydrate(){
                        var r = root(); if(!r) return;
                        if(r.dataset.ltyHydrated === '1') return;
                        r.dataset.ltyHydrated = '1';
                        if(state.data){ render(); return; }
                        var mail = r.dataset.customerEmail || state.email;
                        if(!mail){ try { mail = localStorage.getItem(LS_KEY) || ''; } catch(e){} }
                        if(mail){
                          var i = q('[data-lty-email]'); if(i) i.value = mail;
                          lookup(mail, true);
                        }
                      }

                      window.__thgLty = { hydrate: hydrate };

                      // Re-hidrata cuando Moxie vuelve a pintar el drawer.
                      // La marca ltyHydrated evita que los cambios que hace render()
                      // vuelvan a disparar el observer en bucle.
                      var pending = false;
                      function scheduleHydrate(){
                        if(pending) return;
                        pending = true;
                        setTimeout(function(){ pending = false; hydrate(); }, 80);
                      }
                      new MutationObserver(function(muts){
                        for(var i = 0; i < muts.length; i++){
                          if(muts[i].type !== 'childList') continue;
                          var r = root();
                          if(r && r.dataset.ltyHydrated !== '1'){ scheduleHydrate(); return; }
                        }
                      }).observe(document.body, { childList:true, subtree:true });

                      ['cart:refresh','cart:update','cart:change'].forEach(function(ev){
                        document.addEventListener(ev, function(){ scheduleHydrate(); });
                      });

                      if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hydrate);
                      else hydrate();
                    })();

(function(){
  if(window.__thgLtyGuard) return;
  window.__thgLtyGuard = true;

  function apply(){
    fetch('/cart.js', { headers:{'Accept':'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var items = cart.items || [];
        var hasGift = items.some(function(i){ return (i.original_line_price || i.line_price || 0) === 0; });
        var hasPaid = items.some(function(i){ return (i.original_line_price || i.line_price || 0) > 0; });
        var blocked = hasGift && !hasPaid;

        var btn  = document.getElementById('loyalty-checkout-btn');
        var warn = document.getElementById('loyalty-checkout-warn');
        if(btn){
          btn.disabled = blocked;
          btn.style.opacity = blocked ? '0.5' : '1';
          btn.style.cursor  = blocked ? 'not-allowed' : 'pointer';
        }
        if(warn) warn.style.display = blocked ? 'block' : 'none';
      })
      .catch(function(){});
  }

  ['cart:refresh','cart:update','cart:change'].forEach(function(ev){
    document.addEventListener(ev, apply);
  });
  document.addEventListener('DOMContentLoaded', apply);
  if(document.readyState !== 'loading') apply();
})();